<template>
  <b-form @submit="onSubmitForm">
    <div class="">
      <b-row>
        <b-col cols="12">
          <div class="card title text-center mt-0">
            <h4 class="mb-0">{{ dashboardName }}</h4>
          </div>
        </b-col>
      </b-row>

      <!-- ROW 1 : startdate / enddate -->
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6">
          <span class="font-italic">วันเดือนปี เริ่มต้น </span
          ><span class="text-danger">*</span>
          <b-form-group label="" label-for="startdateSearch">
            <b-form-datepicker
              id="startdateSearch"
              v-model="search.startDate"
              class="mb-2"
              locale="th"
              :hide-header="true"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              today-button
              reset-button
              close-button
              label-today-button="เลือกวันนี้"
              label-reset-button="ล้างปฏิทิน"
              label-close-button="ปิดปฏิทิน"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <span class="font-italic">วันเดือนปี สิ้นสุด </span
          ><span class="text-danger">*</span>
          <b-form-group label="" label-for="enddateSearch">
            <b-form-datepicker
              id="enddateSearch"
              v-model="search.endDate"
              class="mb-2"
              locale="th"
              :hide-header="true"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              today-button
              reset-button
              close-button
              label-today-button="เลือกวันนี้"
              label-reset-button="ล้างปฏิทิน"
              label-close-button="ปิดปฏิทิน"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <!-- <b-col cols="12" sm="12" md="12" lg="12">
          <div class="d-flex justify-content-end text-danger font-italic">
            ช่วงวันที่ค้นหาล่าสุด {{ firstDate }} - {{ lastDate }}
          </div>
        </b-col> -->
      </b-row>

      <!-- ROW 2 : search button -->
      <b-row class="border-bottom justify-content-center">
        <b-col cols="12" sm="12" md="3" lg="2">
          <b-button pill variant="primary" type="submit" block class="mb-1">
            ค้นหา
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "@/views/filters/components/InputFilter.vue";
import moment from "moment";
export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
    BFormDatepicker,
  },
  props: {
    dashboardName: {
      type: String,
      default: "",
    },
    autoSearch: {
      type: Boolean,
      default: false,
    },
  },
  // setup(props) {
  //   let firstdate = moment()
  //     .startOf("month")
  //     .format("DD-MM-YYYY");
  //   let lastdate = moment()
  //     .endOf("month")
  //     .format("DD/MM/YYYY");
  //   // let firstdate = moment().startOf("month");
  //   // let lastdate = moment().endOf("month");
  //   let demo = "2024-05-06";
  //   //console.log"@setup firstdate", firstdate);
  //   //console.log"@setup firstdate typeof", typeof firstdate);
  //   //console.log"@setup lastdate", lastdate);
  //   //console.log"@setup lastdate typeof", typeof lastdate);
  //   const searchList = [
  //     {
  //       id: "startdateSearch",
  //       label: "วันเดือนปี เริ่มต้น",
  //       value: "2024-05-06",
  //       class: "",
  //       style: "",
  //       // placeholder: "วันเดือนปี เริ่มต้น",
  //       type: "dashboard",
  //       options: [],
  //     },
  //     {
  //       id: "enddateSearch",
  //       label: "วันเดือนปี สิ้นสุด",
  //       value: lastdate,
  //       class: "",
  //       style: "",
  //       // placeholder: "วันเดือนปี สิ้นสุด",
  //       type: "dashboard",
  //       options: [],
  //     },
  //   ];
  //   return {
  //     search: searchList,
  //     props,
  //   };
  // },
  data() {
    // const firstDate = moment()
    //   .startOf("month")
    //   .format("DD-MM-YYYY");
    // const lastDate = moment()
    //   .endOf("month")
    //   .format("DD-MM-YYYY");
    return {
      search: {
        startDate: null,
        endDate: null,
      },
      firstDate: moment()
        .startOf("month")
        .format("DD-MM-YYYY"),
      lastDate: moment()
        .endOf("month")
        .format("DD-MM-YYYY"),
    };
  },
  mounted() {
    // //console.log"mounted.dashboard.searchfilter", this.search);
    // if (this.autoSearch === true) {
    //   this.onSubmitForm();
    // }
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onEmit();
    },
    onEmit() {
      let success = true;
      // console.log("@emit search", this.search);

      if (
        this.search.startDate === null ||
        this.search.startDate === "" ||
        this.search.endDate === null ||
        this.search.endDate === ""
      ) {
        // //console.log"@emit A", success);
        success = false;
      }

      if (Date.parse(this.search.endDate) < Date.parse(this.search.startDate)) {
        // //console.log"@emit B", success);
        success = false;
      }

      if (success === false) {
        // //console.log"C");
        this.$swal({
          title: "",
          text: "กรุณากรอกและตรวจสอบช่วงวันเดือนปีที่ต้องการค้นหาให้ถูกต้อง",
          icon: "warning",
          confirmButtonText: "ปิด",
          customClass: {
            confirmButton: "btn btn-warning",
            cancelButton: "btn btn-outline-warning ml-1",
          },
          buttonsStyling: false,
        }).then(() => {
          // //console.log"@swal close");
          return;
        });
      } else {
        // console.log("@emit action", success);

        this.firstDate = this.search.startDate;
        this.lastDate = this.search.endDate;

        this.$emit("handleSubmit", this.search);
      }
    },
    // onDateChange(isStart, vDate) {
    //   //console.log"@onDateChange isStart", isStart);
    //   //console.log"@onDateChange vDate", vDate);
    //   if (isStart === true) {
    //     this.search.startDate = vDate;
    //   } else if (isStart === false) {
    //     this.search.startDate = v;
    //   } else {
    //     this.search = {
    //       startDate: moment()
    //         .startOf("month")
    //         .format("DD-MM-YYYY"),
    //       endDate: moment()
    //         .endOf("month")
    //         .format("DD-MM-YYYY"),
    //     };
    //   }
    //   //console.log"@onDateChange search", this.search);
    // },
    // onStartDateChange(v) {
    //   this.search.startDate = v;
    //   //console.log"@onDateChange", v);
    // },
    // onEndDateChange(v) {
    //   //console.log"@onDateChange", v);
    //   this.search.startDate = v;
    // },
    // onDateChange(v) {
    //   //console.log"@onDateChange", v);
    // },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.search-size {
  width: 20%;
}
</style>
